import React from 'react'
import axios from 'axios'
import { Routes, Route, useNavigate, Navigate } from 'react-router-dom'
import { ThemeProvider, Box, CircularProgress } from '@mui/material'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useLogout } from './hooks/useLogout'
import UserRoutes from './routes/UserRoutes'
import AdminRoutes from './routes/AdminRoutes'
import { useCustomTheme } from './context/ThemeContext'
import LandingPage from './pages/LandingPage/LandingPage'
import Signup from './pages/Auth/Signup'
import ResetPassword from './pages/Auth/ResetPassword'
import { useAuthContext } from './hooks/useAuthContext'
import Login from './pages/Auth/Login'

export default function App() {
  const { user, loading } = useAuthContext()
  const { theme } = useCustomTheme()
  const { logout } = useLogout()
  const navigate = useNavigate()

  if (loading) {
    return (
      <ThemeProvider theme={theme}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100vw',
          }}
        >
          <CircularProgress size={40} color="primary" />
        </Box>
      </ThemeProvider>
    )
  }

  axios.interceptors.response.use(undefined, (error) => {
    if (error.response?.status === 401) {
      logout()
      navigate('/login')
      return Promise.reject(error)
    } else {
      return Promise.reject(error)
    }
  })

  return (
    <ThemeProvider theme={theme}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={!user ? <Login /> : <Navigate to={'/tasks'} />} />
          <Route path="/login/:info" element={!user ? <Login /> : <Navigate to={'/tasks'} />} />
          <Route path="/signup" element={!user ? <Signup /> : <Navigate to={'/tasks'} />} />
          <Route
            path="/reset-password"
            element={!user ? <ResetPassword /> : <Navigate to={'/tasks'} />}
          />
          <Route path="/admin/*" element={<AdminRoutes />} />
          <Route path="/*" element={<UserRoutes />} />
          <Route path="*" element={<Navigate to={'/'} />} />
        </Routes>
        <ToastContainer />
    </ThemeProvider>
  )
}
